import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
export var getQueryStringByObject = function getQueryStringByObject(paramObject) {
  return Object.keys(paramObject).map(function (key) {
    return "".concat(key, "=").concat(paramObject[key]);
  }).join('&');
};